import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "w-100 mw-600px mx-auto mb-10" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "fv-row mb-10 text-start" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col-md-12 fv-row mt-0" }, " Are you sure to discard changes? ")
  ])
], -1)
const _hoisted_2 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_VZModal = _resolveComponent("VZModal")!

  return (_openBlock(), _createBlock(_component_VZModal, {
    title: "Confirmation",
    id: "vz_confirmation_discard",
    showClose: !_ctx.loading,
    maxWidth: "mw-900px",
    widthClass: 'width-550',
    showDialog: _ctx.showDialog,
    onModalClose: _ctx.close
  }, {
    actions: _withCtx(() => [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-outline btn-outline-primary btn-active-light-primary min-w-90px",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args))),
        disabled: _ctx.loading
      }, " Close ", 8, _hoisted_2),
      _createElementVNode("button", {
        type: "button",
        class: "min-w-90px btn btn-outline btn-outline-danger btn-active-light-danger",
        onClick: _cache[1] || (_cache[1] = 
          () => {
            _ctx.$emit('confirm-discard');
          }
        )
      }, " Confirm ")
    ]),
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["showClose", "showDialog", "onModalClose"]))
}